import type { ThemeConfig } from 'antd'

/**
 * 企业简洁风（Corporate Clean）：
 * 深蓝主色 / 浅灰细边 / 8px 圆角 / 柔和阴影 / 无衬线字体
 */
export const corporateTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1e40af',
    colorSuccess: '#10b981',
    colorError: '#ef4444',
    colorWarning: '#f59e0b',
    colorInfo: '#3b82f6',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f8fafc',
    colorBgElevated: '#ffffff',
    colorText: '#111827',
    colorTextSecondary: '#6b7280',
    colorBorder: '#d1d5db',
    colorBorderSecondary: '#e5e7eb',
    borderRadius: 8,
    borderRadiusXS: 4,
    borderRadiusSM: 6,
    borderRadiusLG: 12,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif',
    fontSize: 13,
    lineWidth: 1,
    motion: true,
    wireframe: false,
  },
  components: {
    Card: {
      headerBg: '#ffffff',
      headerFontSize: 14,
      colorBorderSecondary: '#e5e7eb',
    },
    Table: {
      headerBg: '#f8fafc',
      headerColor: '#0f172a',
      headerSplitColor: '#e5e7eb',
      rowHoverBg: '#f1f5f9',
      rowSelectedBg: '#eff6ff',
      rowSelectedHoverBg: '#dbeafe',
      borderColor: '#e5e7eb',
    },
    Button: {
      defaultBg: '#ffffff',
      defaultBorderColor: '#d1d5db',
      defaultColor: '#374151',
      primaryColor: '#ffffff',
      borderRadius: 8,
      fontWeight: 500,
    },
    Input: {
      activeBorderColor: '#3b82f6',
      hoverBorderColor: '#3b82f6',
      colorBgContainer: '#ffffff',
      borderRadius: 8,
    },
    Select: {
      activeBorderColor: '#3b82f6',
      hoverBorderColor: '#3b82f6',
      colorBgContainer: '#ffffff',
      borderRadius: 8,
    },
    DatePicker: {
      activeBorderColor: '#3b82f6',
      hoverBorderColor: '#3b82f6',
      colorBgContainer: '#ffffff',
      borderRadius: 8,
    },
    InputNumber: {
      activeBorderColor: '#3b82f6',
      hoverBorderColor: '#3b82f6',
      colorBgContainer: '#ffffff',
      borderRadius: 8,
    },
    Menu: {
      itemBg: '#ffffff',
      itemHoverBg: '#f1f5f9',
      itemSelectedBg: '#1e40af',
      itemColor: '#374151',
      itemSelectedColor: '#ffffff',
    },
    Modal: {
      headerBg: '#ffffff',
      titleColor: '#0f172a',
      titleFontSize: 14,
    },
    Tabs: {
      cardBg: '#f8fafc',
      itemSelectedColor: '#1e40af',
      cardGutter: 4,
    },
    Tag: {
      defaultBg: '#f8fafc',
      defaultColor: '#374151',
      borderRadiusSM: 6,
    },
    Pagination: {
      itemActiveBg: '#1e40af',
      itemActiveColor: '#ffffff',
    },
    Form: {
      labelColor: '#374151',
    },
    Message: {
      colorBgElevated: '#ffffff',
    },
    Notification: {
      colorBgElevated: '#ffffff',
    },
  },
}
